module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2Utd2lkdGg9IjFwdCI+CiAgICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDUxMi4wMDV2NTEySDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjMDAyNjdmIiBkPSJNMCAwaDE3MC42Njd2NTEySDB6Ii8+CiAgICA8cGF0aCBmaWxsPSIjZjMxODMwIiBkPSJNMzQxLjMzMyAwSDUxMnY1MTJIMzQxLjMzM3oiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/nc.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/nc.svg
// module chunks = 0